import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5d25bac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "export-dialog" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content" }

import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useMainStore } from "@/store";
import { DialogForExportTypes } from "@/types/export";

import ExportImage from "./ExportImage.vue";
import ExportJSON from "./ExportJSON.vue";
import ExportPDF from "./ExportPDF.vue";
import ExportPPTX from "./ExportPPTX.vue";
import ExportSpecificFile from "./ExportSpecificFile.vue";
import { useI18n } from "vue-i18n";
interface TabItem {
  key: DialogForExportTypes;
  label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, locale } = useI18n();

const mainStore = useMainStore();
const { dialogForExport } = storeToRefs(mainStore);

const setDialogForExport = mainStore.setDialogForExport;

const tabs: TabItem[] = /Mac|Win|Linux|X11/.test(navigator.platform) ? [
  // { key: 'pptist', label: '导出 pptist 文件' },
  { key: "pptx", label: t(`editor.exportDialog.expPptx`) }, // '导出 PPTX'
  { key: "image", label: t(`editor.exportDialog.exportImg`) }, // '导出图片'
  // { key: 'json', label: '导出 JSON' },
  { key: "pdf", label: t(`editor.exportDialog.expPdf`) }, // '打印 / 导出 PDF'
] : [
  { key: "pptx", label: t(`editor.exportDialog.expPptx`) }, // '导出 PPTX'
  { key: "image", label: t(`editor.exportDialog.exportImg`) }, // '导出图片'
];

const currentDialogComponent = computed(() => {
  const dialogMap = {
    image: ExportImage,
    json: ExportJSON,
    pdf: ExportPDF,
    pptx: ExportPPTX,
    pptist: ExportSpecificFile,
  };
  return dialogMap[dialogForExport.value as keyof typeof dialogMap] || null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab", { active: tab.key === _unref(dialogForExport) }]),
          key: tab.key,
          onClick: ($event: any) => (_unref(setDialogForExport)(tab.key))
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentDialogComponent)), {
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(setDialogForExport)('')))
      }, null, 32))
    ])
  ]))
}
}

})